import React from "react";
import BusinessForm from "./BusinessForm";

const AddBusiness = () => {
  return <BusinessForm mode="create" />;
};

export default AddBusiness;
